(function () {
  if (window.KootaCartUXLoaded) return;
  window.KootaCartUXLoaded = true;

  var pendingUndo = null;
  var undoTimer = null;
  var pendingUndoExpiry = null;
  var summaryViewTracked = false;
  var trackedUpsellViews = {};

  function pushEvent(name, parameters) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, parameters || {}));
  }

  function parseJSON(value, fallback) {
    try {
      return JSON.parse(value || '');
    } catch (error) {
      return fallback;
    }
  }

  function getSectionIds() {
    var ids = [];
    var drawer = document.querySelector('cart-drawer');
    var mainItems = document.getElementById('main-cart-items');
    var mainFooter = document.getElementById('main-cart-footer');

    if (drawer) ids.push('cart-drawer', 'cart-icon-bubble');
    if (mainItems && mainItems.dataset.id) ids.push(mainItems.dataset.id);
    if (mainFooter && mainFooter.dataset.id) ids.push(mainFooter.dataset.id);

    return ids.filter(function (id, index, list) {
      return list.indexOf(id) === index;
    });
  }

  function addItem(item, source) {
    var sections = getSectionIds();
    return fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Ajout impossible.');
          return data;
        });
      })
      .then(function (data) {
        var eventName = source === 'upsell' ? 'add_cart_upsell' : source === 'undo' ? 'restore_cart_item' : 'add_to_cart';
        pushEvent(eventName, {
          variant_id: item.id,
          quantity: item.quantity,
          source: source
        });
        renderAddedItem(data);
        return data;
      });
  }

  function replaceSection(sectionId, targetSelector, sourceSelector, html) {
    var target = document.querySelector(targetSelector);
    if (!target || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var source = parsed.querySelector(sourceSelector);
    if (source) target.innerHTML = source.innerHTML;
  }

  function renderAddedItem(data) {
    var drawer = document.querySelector('cart-drawer');
    var isCartPage = window.location.pathname === '/cart' || document.body.classList.contains('template-cart');
    if (!isCartPage && drawer && data.sections && data.sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ id: data.id || (data.items && data.items[0] && data.items[0].id), sections: data.sections });
      window.setTimeout(hydrateCartUX, 100);
      return;
    }

    var mainItems = document.getElementById('main-cart-items');
    var mainFooter = document.getElementById('main-cart-footer');
    if (mainItems && data.sections && data.sections[mainItems.dataset.id]) {
      replaceSection(mainItems.dataset.id, '#main-cart-items .js-contents', '.js-contents', data.sections[mainItems.dataset.id]);
    }
    if (mainFooter && data.sections && data.sections[mainFooter.dataset.id]) {
      replaceSection(mainFooter.dataset.id, '#main-cart-footer .js-contents', '.js-contents', data.sections[mainFooter.dataset.id]);
    }
    if (data.sections && data.sections['cart-icon-bubble']) {
      replaceSection('cart-icon-bubble', '#cart-icon-bubble', '.shopify-section', data.sections['cart-icon-bubble']);
    }
    window.setTimeout(hydrateCartUX, 100);
  }

  function trackUpsellViews() {
    document.querySelectorAll('.kc-upsell').forEach(function (upsell) {
      var button = upsell.querySelector('[data-koota-upsell]');
      var surface = upsell.closest('[data-koota-cart-surface]') ? upsell.closest('[data-koota-cart-surface]').dataset.kootaCartSurface : 'page';
      var viewKey = surface + ':' + (button ? button.dataset.variantId : 'unknown');
      if (trackedUpsellViews[viewKey]) return;
      trackedUpsellViews[viewKey] = true;
      upsell.dataset.viewTracked = 'true';
      pushEvent('view_cart_upsell', {
        cart_surface: surface,
        variant_id: button ? Number(button.dataset.variantId) : undefined
      });
    });
  }

  function trackSummaryView() {
    var summary = document.querySelector('[data-koota-cart-summary]');
    if (!summary || summaryViewTracked) return;

    if (!('IntersectionObserver' in window)) {
      summaryViewTracked = true;
      summary.dataset.viewTracked = 'true';
      pushEvent('view_cart_summary');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      summaryViewTracked = true;
      summary.dataset.viewTracked = 'true';
      pushEvent('view_cart_summary');
      observer.disconnect();
    }, { threshold: 0.5 });
    observer.observe(summary);
  }

  function hydrateCartUX() {
    checkShippingThreshold();
    trackUpsellViews();
    trackSummaryView();
  }

  function prepareUndo(removeButton) {
    pendingUndo = {
      id: Number(removeButton.dataset.kootaItem),
      line: Number(removeButton.dataset.index),
      quantity: Number(removeButton.dataset.kootaQuantity) || 1,
      properties: parseJSON(removeButton.dataset.kootaProperties, {}),
      selling_plan: removeButton.dataset.kootaSellingPlan || null,
      name: removeButton.dataset.kootaProductName || 'Le produit'
    };

    window.clearTimeout(pendingUndoExpiry);
    pendingUndoExpiry = window.setTimeout(function () {
      pendingUndo = null;
    }, 10000);
  }

  function revealUndo() {
    var undo = document.querySelector('[data-koota-undo]');
    if (!undo || !pendingUndo) return;

    var message = undo.querySelector('[data-koota-undo-message]');
    if (message) message.textContent = pendingUndo.name + ' a été retiré.';
    window.clearTimeout(undoTimer);
    window.clearTimeout(pendingUndoExpiry);
    undo.hidden = false;
    undoTimer = window.setTimeout(function () {
      undo.hidden = true;
      pendingUndo = null;
    }, 7000);
  }

  function handleUndo() {
    if (!pendingUndo) return;
    var item = {
      id: pendingUndo.id,
      quantity: pendingUndo.quantity,
      properties: pendingUndo.properties
    };
    if (pendingUndo.selling_plan) item.selling_plan = pendingUndo.selling_plan;

    var undo = document.querySelector('[data-koota-undo]');
    var undoButton = undo && undo.querySelector('[data-koota-undo-button]');
    if (undoButton) {
      undoButton.disabled = true;
      undoButton.setAttribute('aria-busy', 'true');
    }
    var message = undo && undo.querySelector('[data-koota-undo-message]');
    if (message) message.textContent = 'Restauration en cours…';
    addItem(item, 'undo')
      .then(function () {
        if (undo) undo.hidden = true;
        window.clearTimeout(undoTimer);
        pendingUndo = null;
      })
      .catch(function (error) {
        if (undoButton) {
          undoButton.disabled = false;
          undoButton.removeAttribute('aria-busy');
        }
        if (message) message.textContent = error.message;
      });
  }

  function handleUpsell(button) {
    if (button.disabled) return;
    var status = button.closest('.kc-upsell').querySelector('[data-koota-upsell-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    if (status) status.textContent = 'Ajout en cours…';

    pushEvent('select_cart_upsell', {
      upsell_product_id: Number(button.dataset.productId),
      variant_id: Number(button.dataset.variantId),
      product_name: button.dataset.productName
    });

    addItem({ id: Number(button.dataset.variantId), quantity: 1 }, 'upsell')
      .then(function () {
        if (status) status.textContent = 'Ajouté au panier ✓';
      })
      .catch(function (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        if (status) status.textContent = error.message;
      });
  }

  function handleVariantChange(button) {
    var panel = button.closest('.kc-item__edit-panel');
    var select = panel.querySelector('[data-koota-variant-select]');
    var status = panel.querySelector('[data-koota-variant-status]');
    var newVariant = Number(select.value);
    var currentVariant = Number(button.dataset.currentVariant);

    if (newVariant === currentVariant) {
      if (status) status.textContent = 'Cette variante est déjà sélectionnée.';
      return;
    }

    var item = {
      id: newVariant,
      quantity: Number(button.dataset.quantity) || 1,
      properties: parseJSON(button.dataset.properties, {})
    };
    if (button.dataset.sellingPlan) item.selling_plan = button.dataset.sellingPlan;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Modification en cours…';

    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Modification impossible.');
          return data;
        });
      })
      .then(function () {
        var cartItems = button.closest('cart-drawer-items') || button.closest('cart-items');
        if (!cartItems || typeof cartItems.updateQuantity !== 'function') throw new Error('Actualisation du panier impossible.');
        cartItems.updateQuantity(button.dataset.line, 0, '');
        pushEvent('edit_cart_variant', {
          variant_id: newVariant,
          previous_variant_id: currentVariant,
          quantity: item.quantity
        });
      })
      .catch(function (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (status) status.textContent = error.message;
      });
  }

  function handleDiscount(form) {
    var input = form.querySelector('[name="discount"]');
    var status = form.querySelector('[data-koota-discount-status]');
    var code = input.value.trim();
    if (!code) {
      if (status) status.textContent = 'Saisissez votre code.';
      return;
    }
    pushEvent('apply_coupon', { coupon: code });
    if (status) status.textContent = 'Application du code…';
    var redirect = window.location.pathname === '/cart' ? '/cart' : window.location.pathname;
    window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect));
  }

  function checkShippingThreshold() {
    var shipping = document.querySelector('[data-koota-shipping].is-unlocked');
    if (!shipping) return;
    try {
      if (sessionStorage.getItem('kootaShippingReached') === '1') return;
      sessionStorage.setItem('kootaShippingReached', '1');
    } catch (error) {
      // Le tracking ne doit jamais empêcher le panier de fonctionner.
    }
    pushEvent('free_shipping_threshold_reached', {
      cart_value: Number(shipping.dataset.cartValue) / 100,
      shipping_threshold_remaining: 0
    });
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('active');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      pushEvent(isOpen ? 'open_cart_drawer' : 'close_cart_drawer', {
        device_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (event) {
    var activeEditor = event.target.closest('.kc-item__edit');
    document.querySelectorAll('.kc-item__edit[open]').forEach(function (editor) {
      if (editor !== activeEditor) editor.removeAttribute('open');
    });

    var upsell = event.target.closest('[data-koota-upsell]');
    if (upsell) {
      event.preventDefault();
      handleUpsell(upsell);
      return;
    }

    var variantSave = event.target.closest('[data-koota-variant-save]');
    if (variantSave) {
      event.preventDefault();
      handleVariantChange(variantSave);
      return;
    }

    var remove = event.target.closest('cart-remove-button[data-koota-item]');
    if (remove) {
      prepareUndo(remove);
      return;
    }

    var undoButton = event.target.closest('[data-koota-undo-button]');
    if (undoButton) {
      event.preventDefault();
      handleUndo();
      return;
    }

    var checkout = event.target.closest('[data-koota-checkout]');
    if (checkout) {
      if (checkout.classList.contains('is-loading')) {
        event.preventDefault();
        return;
      }
      var originalCheckoutContent = checkout.innerHTML;
      checkout.classList.add('is-loading');
      checkout.setAttribute('aria-busy', 'true');
      checkout.setAttribute('aria-disabled', 'true');
      checkout.textContent = 'Ouverture du paiement…';
      pushEvent('begin_checkout', {
        cart_value: Number(checkout.dataset.cartValue || 0) / 100,
        cart_item_count: Number(checkout.dataset.cartItemCount || 0),
        discount_amount: Number(checkout.dataset.discountAmount || 0) / 100,
        device_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
        cart_surface: checkout.dataset.cartSurface || 'page'
      });
      window.setTimeout(function () {
        if (!document.contains(checkout)) return;
        checkout.classList.remove('is-loading');
        checkout.removeAttribute('aria-busy');
        checkout.removeAttribute('aria-disabled');
        checkout.innerHTML = originalCheckoutContent;
      }, 8000);
      return;
    }

    var continueShopping = event.target.closest('[data-koota-continue-shopping]');
    if (continueShopping) {
      pushEvent('continue_shopping_from_cart', {
        cart_surface: continueShopping.dataset.cartSurface || 'page'
      });
      return;
    }

    var promoSummary = event.target.closest('.kc-promo > summary');
    if (promoSummary) {
      pushEvent('toggle_cart_promo', {
        action: promoSummary.parentElement.open ? 'close' : 'open'
      });
      return;
    }

    var expressCheckout = event.target.closest('.additional-checkout-buttons button, .additional-checkout-buttons [role="button"]');
    if (expressCheckout) {
      pushEvent('select_express_checkout', {
        device_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
      });
    }
  });

  document.addEventListener('submit', function (event) {
    var discountForm = event.target.closest('[data-koota-discount-form]');
    if (!discountForm) return;
    event.preventDefault();
    handleDiscount(discountForm);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var editor = document.activeElement && document.activeElement.closest('.kc-item__edit[open]');
    if (!editor) return;
    editor.removeAttribute('open');
    var summary = editor.querySelector('summary');
    if (summary) summary.focus();
  });

  document.addEventListener('DOMContentLoaded', function () {
    hydrateCartUX();
    watchDrawer();

    if (window.location.pathname === '/cart' || document.body.classList.contains('template-cart')) {
      var checkout = document.querySelector('[data-koota-checkout][data-cart-surface="page"]');
      pushEvent('view_cart', {
        cart_value: checkout ? Number(checkout.dataset.cartValue || 0) / 100 : 0,
        cart_item_count: checkout ? Number(checkout.dataset.cartItemCount || 0) : 0
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.source === 'cart-items') {
          if (Number(event.quantity) === 0 && pendingUndo && pendingUndo.line === Number(event.line)) {
            revealUndo();
            pushEvent('remove_from_cart', {
              variant_id: pendingUndo.id,
              product_name: pendingUndo.name,
              quantity: pendingUndo.quantity
            });
          } else {
            pushEvent('update_cart_quantity', {
              quantity: event.quantity,
              previous_quantity: event.previousQuantity,
              cart_value: event.cart && event.cart.total_price ? event.cart.total_price / 100 : undefined,
              cart_item_count: event.cart && event.cart.item_count
            });
          }
        }
        window.setTimeout(hydrateCartUX, 100);
      });
    }
  });
})();
